import { mkdir, stat, writeFile } from 'node:fs/promises'
import { join, resolve } from 'node:path'
import { Command } from 'commander'

const TEMPLATES: Record<string, (name: string) => string> = {
  application: (name) => `api-version: verentis.io/v1
kind: Application

metadata:
  name: ${name}
  display-name: ${titleCase(name)}
  description: ""
  icon: layout-dashboard
  version: 0.1.0
  author: ""

spec:
  entry: https://example.com   # hosted app origin
  scope: global

  entry-points: []
  capabilities: []
  permissions: []

  sandbox:
    allow-scripts: true
    allow-same-origin: true
    allow-popups: false
    allow-forms: true

packaging:
  publisher: ""                # your publisher name
  files: []                    # globs relative to this manifest, e.g. ["schemas/**/*.json"]
  encryption: none
`,
  engine: (name) => `api-version: verentis.io/v1
kind: ExecutionEngine

metadata:
  name: ${name}
  display-name: ${titleCase(name)}
  description: ""
  icon: lucide:terminal
  version: 0.1.0
  author: ""

spec:
  runtimes: {}
  file-types: []
  execution-modes:
    - request-response

packaging:
  publisher: ""                # your publisher name
  files: []                    # e.g. ["dist/runner.js"] — reference as ./runner.js in spec
  encryption: none
`,
  bundle: (name) => `api-version: verentis.io/v1
kind: Bundle

metadata:
  name: ${name}
  display-name: ${titleCase(name)}
  description: ""
  version: 0.1.0
  author: ""

packaging:
  publisher: ""                # your publisher name
  files:
    - "content/**/*"           # everything under content/ is installed at the target path
  bundle:
    default-path: /data/${name}
  encryption: none
`,
}

export function registerInit(program: Command): void {
  program
    .command('init [dir]')
    .description('Scaffold a manifest.yaml for a new package')
    .option('--kind <kind>', 'application | engine | bundle', 'application')
    .option('--name <name>', 'package name (defaults to the directory name)')
    .action(async (dir: string | undefined, options: { kind: string; name?: string }) => {
      const template = TEMPLATES[options.kind.toLowerCase()]
      if (!template) throw new Error(`Unknown kind '${options.kind}' — use application, engine or bundle.`)

      const targetDir = resolve(dir ?? '.')
      await mkdir(targetDir, { recursive: true })
      const name = (options.name ?? targetDir.split('/').pop() ?? 'my-package').toLowerCase().replace(/[^a-z0-9-]/g, '-')

      const manifestPath = join(targetDir, 'manifest.yaml')
      if (await exists(manifestPath)) throw new Error(`${manifestPath} already exists.`)
      await writeFile(manifestPath, template(name))
      console.log(`Created ${manifestPath} (kind: ${options.kind}).`)
      console.log('Fill in packaging.publisher and packaging.files, then run `verentis pack`.')
    })
}

async function exists(path: string): Promise<boolean> {
  try {
    await stat(path)
    return true
  } catch {
    return false
  }
}

function titleCase(value: string): string {
  return value.replace(/(^|[-_])(\w)/g, (_, __, c: string) => ` ${c.toUpperCase()}`).trim()
}
